import http from './request';

const getDepartmentList = () => http.get('/banyan/consultation/listDept');
// const searchDoctor = (params) => http.post('/search-service/doctorSearch', { ...params });
const getDoctorDetail = (params) => http.post('/banyan/consultation/doctor/detail', { ...params, });
const toggleFollowDoctor = (params) => http.post('/banyan/consultation/doctor/attention', { ...params, });
const doctorLiveStatus = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/live-platform-service/live/watch/status',
  data: params,
});
const getDoctorDetailInfo = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/maserati/doctor/consultation/detailInfo',
  data: params,
});

const myDoctorList = (params) => http({
  app: 'banyanSi',
  method: 'post',
  // url: '/banyan/attention/doctorList',
  url: '/maserati/doctor/attention/list',
  data: params,
});

const searchDoctor = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/search-engine/consult/doctor/search',
  data: params,
});

const getDoctorPage = (params) =>
  http({
    app: 'banyanSi',
    method: 'post',
    url: '/maserati/doctor/rp/search/expert/getDoctorPage',
    data: params,
  });

const consultDoctorDetail = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/minos/mini/consultDoctor/detail',
  data: params,
});

// 获取医生排班列表
const getDoctorSchedule = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/minos/mini/consult/doctorSchedule/list',
  data: params,
});
// 关注医生
const followDoctorApi = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/minos/mini/consultDoctor/follow',
  data: params,
});
// 取消关注
const cancelFollowApi = (params) => http({
  app: 'banyanSi',
  method: 'post',
  url: '/minos/mini/consultDoctor/cancelFollow',
  data: params,
});
export {
  getDepartmentList,
  searchDoctor,
  getDoctorPage,
  getDoctorDetail,
  getDoctorDetailInfo,
  consultDoctorDetail,
  toggleFollowDoctor,
  doctorLiveStatus,
  myDoctorList,
  getDoctorSchedule,
  followDoctorApi,
  cancelFollowApi
};
